<template>
    <div class="form">
        <Spin fix v-if="loading"></Spin>
        <Form ref="info" :model="info" :rules="ruleValidate" :label-width="100">
            <form-item label="维修费用" prop="feeList">
                <fee-field
                    :repairId="id"
                    :feeList="feeList"
                    :isView="isView"
                    populate-type="chain"
                ></fee-field>
            </form-item>
        </Form>

        <confirm
            :text="confirm.text"
            v-model="confirm.show"
            @closeModal="onConfirmCancel"
            @confirmModal="onConfirmOk"
        />
    </div>
</template>
<script>
import { repairAddFee, repairView } from '@/api/repair'
import FeeField from '_v/daily/repair-fee-field'
import { currency } from '_u/helper'
import Confirm from '_v/components/confirm'

export default {
    name: 'repairAddForm',
    components: { FeeField, Confirm },
    props: {
        id: {
            type: [String, Number],
            default: '',
        },
    },
    inject: {
        $modal: {
            default: null,
        },
    },
    data() {
        return {
            loading: false,
            info: {
                id: '', // 数据编号
                cancelRemark: '',
            },
            feeList: [], //维修费用列表
            dict: {
                repairFeeType: this.$dict.NULL,
            },
            confirm: {
                text: '添加后租客对应的维修工单出现一笔待支付费用项，是否确定',
                show: false,
            },
            originFeeListLength: 0, //入参feeList的原始长度,用于和修改后的对比
        }
    },

    computed: {
        ruleValidate() {
            return {
                cancelRemark: [
                    {
                        required: true,
                        message: '原因必填',
                    },
                ],
            }
        },
        user() {
            return this.$store.state.user.info
        },
        isView() {
            return (
                //已交 只能view不能改
                //已归档3/已取消4 只能view不能改
                this.feeList.some((o) => o.repairPayStatus === '2') ||
                ['3', '4'].includes(this.info.repairStatus)
            )
        },
    },
    methods: {
        fetch() {
            this.loading = true
            return Promise.all([
                this.$dict.get(['repair_fee_type']),
                repairView(this.id),
            ]).then((r) => {
                const [group, resp] = r
                Object.assign(this.dict, group)

                if (resp.data.feeList?.length > 0) {
                    this.feeList = resp.data.feeList.map((o) => {
                        o.amount = currency(parseFloat(o.amount) / 100)
                        return o
                    })
                    this.originFeeListLength = this.feeList.length
                }
                if (resp.data) {
                    this.info = resp.data.entity
                }
                this.initBtns()
            })
        },
        initBtns() {
            // 按钮配置
            const btns = []
            if (this.isView) {
                btns.unshift({
                    type: 'default',
                    name: 'cancel',
                    text: '关闭',
                })
            } else {
                btns.unshift({
                    type: 'default',
                    name: 'cancel',
                    text: '取消',
                })
                btns.unshift({
                    type: 'primary',
                    name: 'confirm',
                    text: '确定',
                })
            }
            this.$modal.updateBtns(btns)
        },
        onConfirmOk() {
            const t = this
            this.loading = true
            return this.$refs.info
                .validate()
                .then(() => {
                    const info = t.$refs.info.populateData()
                    // clog(info)
                    const p = {
                        repairId: this.id,
                        list: JSON.stringify(
                            info.hasOwnProperty('feeList')
                                ? info.feeList.map((o) => {
                                      o.amount = parseFloat(o.amount) * 100
                                      return o
                                  })
                                : []
                        ),
                    }
                    return repairAddFee(p)
                    // options.closeModal = false
                    // return Promise.resolve()
                })
                .then((res) => {
                    this.$Message.success('费用添加成功')
                    this.$emit('second-confirm')
                    this.$modal.close()
                })
                .catch((err) => {
                    clog(err)
                })
                .finally(() => {
                    this.loading = false
                })
        },
        onConfirmCancel() {
            this.confirm.show = false
        },
    },

    mounted() {
        const t = this

        // 预加载
        this.$modal.beforeEnter((next) => {
            this.loading = true
            this.fetch()
                .then((r) => {
                    next()
                })
                .finally((_) => {
                    this.loading = false
                })
        })

        // 确定
        this.$modal.onBtnClick('confirm', (next, options) => {
            const isModified = t.feeList.length !== t.originFeeListLength
            if (isModified) {
                if (t.feeList.length > 0) {
                    //有费用,提示发消息
                    if (!this.loading) {
                        this.confirm.show = true
                        options.closeModal = false
                        next()
                    }
                } else {
                    //无费用,直接关闭
                    this.onConfirmOk().then(() => {
                        next()
                    })
                }
            } else {
                next()
            }
        })
    },
}
</script>
<style lang="less" scoped></style>
